import type { PostApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsBody } from '@fukuri-admins/apis/client/gen/model';
import { format } from 'date-fns';

type IGenerateRequestBody = (values: {
  contractPlanId: string;
  startedOn: Date;
  endedOn?: Date | null;
}) => PostApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContractsBody;

/**
 * フォームのフィールド値を API リクエストボディに変換する
 *
 * - contractPlanId: string → number 変換
 * - startedOn / endedOn: Date → 'yyyy-MM-dd' 文字列変換
 * - endedOn が未設定の場合は null を送信（無期限）
 */
export const generateRequestBody: IGenerateRequestBody = ({
  contractPlanId,
  startedOn,
  endedOn,
}) => ({
  client_contract: {
    contract_plan_id: Number(contractPlanId),
    started_on: format(startedOn, 'yyyy-MM-dd'),
    ended_on: endedOn ? format(endedOn, 'yyyy-MM-dd') : null,
  },
});
